import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type AdvisoryNeedDto, getAdvisoryNeeds } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useAdvisoryNeeds(): UseQueryResult<AdvisoryNeedDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.advisoryNeeds(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getAdvisoryNeeds({ signal }).then((result) => result.data),
    });
}
